var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h3',{staticClass:"register-title"},[_vm._v("注册")]),_c('a-form',{attrs:{"form":_vm.form},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'username',
          {
            rules: [
              {
                required: true,
                message: '请输入用户名！'
              },
              {
                type: 'username',
                message: '用户名格式错误'
              }
            ]
          }
        ]),expression:"[\n          'username',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请输入用户名！'\n              },\n              {\n                type: 'username',\n                message: '用户名格式错误'\n              }\n            ]\n          }\n        ]"}],attrs:{"size":"large","placeholder":"用户名"}})],1),_c('a-form-item',{attrs:{"help":_vm.help}},[_c('a-popover',{attrs:{"overlayStyle":{ width: '240px' },"placement":"right","visible":_vm.visible}},[_c('template',{slot:"content"},[_c('div',{staticStyle:{"padding":"4px 0"}},[_c('VNodes',{attrs:{"vnodes":_vm.passwordStatusMap()}}),_c('VNodes',{attrs:{"vnodes":_vm.renderPasswordProgress()}}),_c('div',{staticStyle:{"margin-top":"10"}},[_vm._v("\n              请至少输入 6 个字符。请不要使用容易被猜到的密码。\n            ")])],1)]),_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'password',
            {
              rules: [{ validator: this.checkPassword }]
            }
          ]),expression:"[\n            'password',\n            {\n              rules: [{ validator: this.checkPassword }]\n            }\n          ]"}],attrs:{"type":"password","size":"large","placeholder":"密码，至少6位区分大小写"}})],2)],1),_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'confirm',
          {
            rules: [
              {
                required: true,
                message: '请确认密码！'
              },
              {
                validator: this.checkConfirm
              }
            ]
          }
        ]),expression:"[\n          'confirm',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请确认密码！'\n              },\n              {\n                validator: this.checkConfirm\n              }\n            ]\n          }\n        ]"}],attrs:{"type":"password","size":"large","placeholder":"确认密码"}})],1),_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'mail',
          {
            rules: [
              {
                required: true,
                message: '请输入邮箱地址！'
              },
              {
                type: 'email',
                message: '邮箱地址格式错误！'
              }
            ]
          }
        ]),expression:"[\n          'mail',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请输入邮箱地址！'\n              },\n              {\n                type: 'email',\n                message: '邮箱地址格式错误！'\n              }\n            ]\n          }\n        ]"}],attrs:{"size":"large","placeholder":"邮箱"}})],1),_c('a-form-item',[_c('a-row',{attrs:{"gutter":8}},[_c('a-col',{attrs:{"span":16}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'captcha',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入验证码！'
                  }
                ]
              }
            ]),expression:"[\n              'captcha',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '请输入验证码！'\n                  }\n                ]\n              }\n            ]"}],attrs:{"size":"large","type":"Captcha","placeholder":"验证码"}})],1),_c('a-col',{attrs:{"span":8}},[_c('a-button',{staticClass:"getCaptcha",attrs:{"size":"large","disabled":!!_vm.count},on:{"click":_vm.onGetCaptcha}},[_vm._v(_vm._s(_vm.count ? (_vm.count + " 秒") : "获取验证码"))])],1)],1)],1),_c('a-form-item',[_c('a-button',{staticClass:"submit",attrs:{"size":"large","type":"primary","htmlType":"submit","loading":_vm.submitting}},[_vm._v("注册")]),_c('router-link',{staticClass:"login",attrs:{"to":"/user/login"}},[_vm._v("使用已有账户登录")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }